import { render, staticRenderFns } from "./ProfilKl.vue?vue&type=template&id=d88e5626"
import script from "./ProfilKl.vue?vue&type=script&lang=js"
export * from "./ProfilKl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports